export default __webpack_public_path__ + "static/property-img-4-2ef78e25edd2fa140c1e759c827079ca.jpg";